import React, { useState, useRef, useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from 'helpers/api';
import * as mapYourMedsConstant from '../../../common/mapYourMedsConstant.js';

const MedReasonPresForm = (props) => {

    const initialFormData = {
        rsnprescrib: "",
        isactive: true,
        id: ""
    };

    const [formData, setFormData] = useState(initialFormData);
    const [buttonStatus, setButtonStatus] = useState(mapYourMedsConstant.ADD_ACTION);
    const formRef = useRef(null);
    //const navigate = useNavigate();

    useEffect(() => {
        async function setMedRsnDetails() {
            //console.log("set edit details " + props.allergyvalue);

            const { reason, is_active, reason_id } = props.medrsnvalue;
      
            setFormData({
              rsnprescrib: reason || "",
              isactive: is_active == 1 || is_active === true, // normalize boolean
              id: reason_id || ""
            });

            setButtonStatus(mapYourMedsConstant.UPDATE_ACTION);
        }

        if (props.edittrigger > 0) {
            //console.log(props.trigger);
            setMedRsnDetails();
        }
    }, [props.edittrigger]);

    const handleSubmit = async e => {
        e.preventDefault();

        let tokenStr = localStorage.getItem("accessToken");
        let pelmedsPresReasonUrl = buttonStatus == "Add" ? `${process.env.REACT_APP_SERVER_URL}` + "/prescriptions/add-prescription-reason/" : `${process.env.REACT_APP_SERVER_URL}` + "/prescriptions/update-prescription-reason/";
        let pelmedsPresReasonData = buttonStatus == "Add" ? { "reason": formData.rsnprescrib,"group_id" : localStorage.getItem("groupId") || '', "is_active": formData.isactive ? 1 : 0 } :
            { "reason": formData.rsnprescrib,"group_id" : localStorage.getItem("groupId") || '', "is_active": formData.isactive ? 1 : 0, "id": formData.id }

        const { data } = await axios.post(pelmedsPresReasonUrl, pelmedsPresReasonData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

        if (data.status) {
            toast.success("Prescription Reason added/updated successfully");
            //navigate(0);
        }
        else {
            toast.info("Error while adding Prescription Reason");
        }

        //if (buttonStatus != "Edit") {
        setFormData(initialFormData);
        formRef.current.reset();
        //}
        setButtonStatus("Add");

        props.onCallParent();
    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <Form ref={formRef} onSubmit={handleSubmit}>
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">Reason Prescribed</Form.Label>
                        <Form.Control
                            placeholder='Reason Prescribed'
                            value={formData.rsnprescrib}
                            name="rsnprescrib"
                            size="sm"
                            as="textarea"
                            rows={4}
                            onChange={handleFieldChange}
                            type="text"
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group>
                        <Button
                            type="submit"
                            color="primary"
                            className="mt-4 w-50"
                            size="sm"
                            disabled={!formData.rsnprescrib}>
                            {buttonStatus}
                        </Button>
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <Form.Group>
                        <Form.Check
                            type='switch'
                            name="isactive"
                            id='isactive'
                            checked={
                                formData.isactive
                            }
                            onChange={e =>
                                setFormData({
                                    ...formData,
                                    isactive: e.target.checked
                                })
                            }
                            label='Active'
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                </Col>
            </Row>
        </Form>
    );
};
export default MedReasonPresForm;

